import { getPanelDefinition, type PanelWidgetInstance, type WidgetSpan } from './widgetRegistry';

const SPAN_UNITS: Record<WidgetSpan, number> = {
  wide: 6,
  half: 3,
  third: 2,
};

export type ResolvedWidgetSpan = WidgetSpan | 'full';

export function resolveWidgetSpans(panels: PanelWidgetInstance[]): Map<string, ResolvedWidgetSpan> {
  const preferred = panels.map(panel => ({
    id: panel.id,
    units: SPAN_UNITS[getPanelDefinition(panel.type)?.span ?? 'half'] ?? 3,
  }));

  const rows: Array<typeof preferred> = [];
  let current: typeof preferred = [];
  let used = 0;

  preferred.forEach(item => {
    if (current.length && used + item.units > 6) {
      rows.push(current);
      current = [];
      used = 0;
    }
    current.push(item);
    used += item.units;
  });
  if (current.length) rows.push(current);

  const resolved = new Map<string, ResolvedWidgetSpan>();

  rows.forEach(row => {
    if (row.length === 1) {
      resolved.set(row[0].id, 'full');
      return;
    }
    if (row.length === 2) {
      row.forEach(item => resolved.set(item.id, 'half'));
      return;
    }
    if (row.length === 3) {
      row.forEach(item => resolved.set(item.id, 'third'));
      return;
    }
    row.forEach(item => {
      if (item.units >= 6) resolved.set(item.id, 'wide');
      else if (item.units >= 3) resolved.set(item.id, 'half');
      else resolved.set(item.id, 'third');
    });
  });

  return resolved;
}
